"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
/**
 * @internal
 */
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function (e) {
            if (!_this.props.disabled) {
                _this.props.onClick(e);
            }
        };
        return _this;
    }
    Button.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, tagName = _a.tagName, title = _a.title, value = _a.value, tabIndex = _a.tabIndex, type = _a.type, iconLeft = _a.iconLeft, iconRight = _a.iconRight;
        var TagName = tagName;
        return (react_1.default.createElement(TagName, { id: id, ref: function (ref) {
                _this.buttonNode = ref;
            }, title: title, className: this.getClassnames(), type: type, onClick: this._onClick, tabIndex: tabIndex },
            this.renderIcon(iconLeft),
            value ? react_1.default.createElement("span", { className: "gd-button-text" }, value) : null,
            this.renderIcon(iconRight)));
    };
    Button.prototype.getClassnames = function () {
        var _a;
        var value = this.props.value;
        var generatedSeleniumClass = value && typeof value === "string" ? "s-" + util_1.stringUtils.simplifyText(value) : "";
        return classnames_1.default((_a = {},
            _a[this.props.className] = !!this.props.className,
            _a[generatedSeleniumClass] = true,
            _a["gd-button"] = true,
            _a.disabled = this.props.disabled,
            _a));
    };
    Button.prototype.renderIcon = function (icon) {
        if (!icon) {
            return null;
        }
        return react_1.default.createElement("span", { className: classnames_1.default("gd-button-icon", icon), role: "button-icon" });
    };
    Button.defaultProps = {
        className: "",
        disabled: false,
        onClick: noop_1.default,
        tabIndex: -1,
        tagName: "button",
        title: "",
        type: "button",
        value: "",
        iconLeft: null,
        iconRight: null,
    };
    return Button;
}(react_1.default.Component));
exports.Button = Button;
//# sourceMappingURL=Button.js.map